import React from "react";
import { Select } from "risa-oasis-ui_v2";

export interface SelectOption {
  value: string;
  label: string;
}

interface RpaConfigSelectProps {
  id: string;
  label: string;
  options: SelectOption[];
  value: string;
  placeholder?: string;
  onChange: (value: any) => void;
  required?: boolean;
  disabled?: boolean;
}

const RpaConfigSelect: React.FC<RpaConfigSelectProps> = ({
  id,
  label,
  options,
  value,
  placeholder = "Select an option",
  onChange,
  required = false,
  disabled = false,
}) => {
  return (
    <div
      className={`rpa-config-select ${disabled ? "rpa-config-select--disabled" : ""}`}
    >
      <Select
        id={id}
        label={label}
        options={disabled ? [] : options}
        onOptionChange={disabled ? () => {} : onChange}
        defaultValue={value}
        placeholder={disabled ? "Disabled" : placeholder}
        required={required}
      />
    </div>
  );
};

export default RpaConfigSelect;
